import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { COLORS } from "../../theme";
import {imgButtonSkewed} from "../../assets/images/button_skewed";


const LargeOption = (props) => {
  const isMobile = useMediaQuery(useTheme().breakpoints.down("md"), {
    noSsr: true,
  });

  const answerSelected = (value) => {
    if (props.answerSelected) props.answerSelected(value);
  };

  return (
    <Box
      sx={{
        width: { md: "70%", xs: "90%" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {props.quiz &&
        props.quiz.options.map((answer, index) => {
          return (
            <Box
              sx={{
                height: { xs: 60, md: 150 },
                width: { xs: 60, md: 150 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => answerSelected(answer)}
            >

             <Box
                style={{
                  backgroundImage: `url(${imgButtonSkewed}`,
                  backgroundPosition: "50% 50%",
                  width: isMobile?"60px": "150px",
                  height: isMobile?"60px": "150px" ,
                  backgroundRepeat: "no-repeat",
                  backgroundSize:"60px 60px",
                  borderRadius: "10px",
                  position: "absolute",
                }}
              />

              <span
                style={{
                  color: COLORS.white,
                  fontFamily: "'ATGRubrik'",
                  zIndex: 10,
                  fontSize: 20
                }}
              >
                {answer}
              </span>
            </Box>
          );
        })}
    </Box>
  );
};

export default LargeOption;
